import React from 'react';
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { calculateSaleBidSummary, BidSummaryDisplay, prepareSaleItemsData, prepareUserBidsData } from './BidSummaryCalculator';
import { useTranslation } from 'react-i18next';

const SaleSummary = ({ groupedBids, currency, isActive = true, itemDetails }) => {
  const { t } = useTranslation();
  
  const saleItems = prepareSaleItemsData(groupedBids, itemDetails);
  const userBids = prepareUserBidsData(groupedBids);
  const summary = calculateSaleBidSummary(saleItems, userBids);
  const displayData = BidSummaryDisplay({ summary, currency, t }); // Pass t here
  
  const hasWonItems = Object.values(groupedBids).some(lotData =>
    lotData.item.status === 'sold' &&
    lotData.bids.some(bid => bid.id === lotData.item.winning_bid)
  );

  const DataRow = ({ label1, value1, label2, value2, label3, value3, valueColor2 = "gray.600", valueColor3, rowKey }) => (
    <>
      {/* Mobile Layout */}
      <Grid
        display={{ base: 'grid', md: 'none' }}
        templateColumns="auto 1fr"
        gap={2}
        mb={4}
        key={`mobile-${rowKey}`}
        className="bid-summary"
      >
        <GridItem><Text fontWeight="bold">{label1}:</Text></GridItem>
        <GridItem><Text>{value1}</Text></GridItem>
        <GridItem><Text fontWeight="bold">{label2}:</Text></GridItem>
        <GridItem><Text color={valueColor2}>{value2}</Text></GridItem>
        <GridItem><Text fontWeight="bold">{label3}:</Text></GridItem>
        <GridItem><Text color={valueColor3}>{value3}</Text></GridItem>
      </Grid>

      {/* Desktop Layout */}
      <Grid
        display={{ base: 'none', md: 'grid' }}
        templateColumns="repeat(6, 1fr)"
        gap={2}
        mb={2}
        key={`desktop-${rowKey}`}
        className="bid-summary"
      >
        <GridItem><Text fontWeight="bold">{label1}:</Text></GridItem>
        <GridItem><Text>{value1}</Text></GridItem>
        <GridItem><Text fontWeight="bold">{label2}:</Text></GridItem>
        <GridItem><Text color={valueColor2}>{value2}</Text></GridItem>
        <GridItem><Text fontWeight="bold">{label3}:</Text></GridItem>
        <GridItem><Text color={valueColor3}>{value3}</Text></GridItem>
      </Grid>
    </>
  );

  return (
    <Box p={{ base: 2, md: 4 }} borderWidth="1px" borderRadius="lg" bg="white" mb={4}>
      <DataRow
        label1={t('myBids.summary.totalItemsBidOn')}
        value1={displayData.itemsBidOn}
        label2={t('myBids.summary.openingTotal')}
        value2={displayData.openingTotal}
        label3={t('myBids.summary.currentBidsTotal')}
        value3={displayData.topBidTotal}
        valueColor3="blue.600"
        rowKey="bids"
      />
      {hasWonItems && (
        <DataRow
          label1={t('myBids.summary.wonLots')}
          value1={displayData.itemsWon}
          label2={t('myBids.summary.wonOpeningTotal')}
          value2={displayData.wonOpeningTotal}
          label3={t('myBids.summary.soldForTotal')}
          value3={displayData.wonAmount}
          valueColor3="green.600"
          rowKey="won"
        />
      )}
    </Box>
  );
};

export default SaleSummary;